import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsBadgeModule,
    CmpsButtonModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsEventCentreDialogModule } from '../dialog';

import { EventCentreNavButtonComponent } from './event-centre-nav-button.component';

@NgModule({
    declarations: [EventCentreNavButtonComponent],
    imports: [
        CmpsBadgeModule,
        CmpsButtonModule,
        CmpsEventCentreDialogModule,
        CmpsIconModule,
        CmpsTooltipModule,
        CommonModule,
    ],
    exports: [EventCentreNavButtonComponent],
})
export class CmpsEventCentreNavButtonModule {}
